import { takeLatest, put, call, select } from 'redux-saga/effects';
import { COPY_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, bookingFormAction, calendarAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getWeekBookingSagaAction } from "../sagaActions";
import { BOOKING_FORM_INITIAL, CALENDAR_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/copy_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCopyBooking(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const bookingForm = yield select(state => state.bookingForm);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('booking_id', args.data.booking_id);
        formData.append('copy_days', args.data.copy_days);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем записи
            yield put(getWeekBookingSagaAction({
                establishment: currentEstablishment,
                date: bookingForm.date
            }));

            // Закрываем форму редактирования записи
            yield put(bookingFormAction(BOOKING_FORM_INITIAL));
            // Закрываем календарь
            yield put(calendarAction(CALENDAR_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCopyBooking() {
    yield takeLatest(COPY_BOOKING_SAGA, workerCopyBooking);
}